/**
 * Audit events API endpoints — T20.
 * Maps PRD §9.9 to typed fetch calls via apiClient.
 */
import { ListAuditEventsResponseSchema } from '@malaberg/shared';
import { apiClient } from '../client';

export interface ListAuditEventsQuery {
  eventType?: string;
  entityType?: string;
  userId?: string;
  actingUserId?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

function toQueryString(params: Record<string, string | number | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined);
  if (entries.length === 0) return '';
  return `?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
}

export const auditEventsApi = {
  list(query: ListAuditEventsQuery = {}) {
    return apiClient.request(
      'GET',
      `/api/audit-events${toQueryString(query as Record<string, string | number | undefined>)}`,
      {
        schema: ListAuditEventsResponseSchema,
      }
    );
  },

  /** Returns audit events for the currently authenticated user. */
  listMine(query: ListAuditEventsQuery = {}) {
    return apiClient.request(
      'GET',
      `/api/audit-events/me${toQueryString(query as Record<string, string | number | undefined>)}`,
      {
        schema: ListAuditEventsResponseSchema,
      }
    );
  },
};
